import React, { useEffect, useState } from "react";
import { Dropdown, Button, Form } from "semantic-ui-react";
import { APICall } from "../api";

export default function FiltroRicerca({ onSearch }) {
  const [parametri, setParametri] = useState({
    codice: "",
    nazionalita: "",
    zona: "",
    sesso: "",
    citta: "",
    asl: "",
    provincia: "",
    municipi: "",
    cap: "",
    coordinate: "",
    patente: "",
    turni_accessi: "",
    offerta_assistenza: "",
    tipo_collaborazione: "",
    data_consegna_inizio: "",
    data_consegna_fine: "",
    data_colloquio_contatto_inizio: "",
    data_colloquio_contatto_fine: "",
    nome_query: "",
    cognome_query: "",
    telefono_query: "",
  });

  const [loading, setLoading] = useState(false);
  const [resetKey, setResetKey] = useState(0); // reset key state

  const [opzioni, setOpzioni] = useState({
    codice: [],
    cap: [],
    citta: [],
    zona: [],
    provincia: [],
    municipi_distretti_roma: [],
    asl: [],
    nazionalita: [],
    coordinate: [],
    patente: [],
    turni_accessi: [],
    offerta_assistenza: [],
    tipo_collaborazione: [],
  });

  const opzioniSesso = [
    { key: "n", value: "", text: "Tutti" },
    { key: "m", value: "m", text: "Maschio" },
    { key: "f", value: "f", text: "Femmina" },
  ];

  // dropdown configurations
  useEffect(() => {
    const configurazioni = [
      { endpoint: "/codici", chiave: "codice" },
      { endpoint: "/cap", chiave: "cap" },
      { endpoint: "/citta", chiave: "citta" },
      { endpoint: "/zona", chiave: "zona" },
      {
        endpoint: "/provincia",
        chiave: "provincia",
      },
      {
        endpoint: "/municipi",
        chiave: "municipi_distretti_roma",
      },
      { endpoint: "/asl", chiave: "asl" },
      {
        endpoint: "/nazionalita",
        chiave: "nazionalita",
      },
      {
        endpoint: "/coordinate",
        chiave: "coordinate",
      },
      { endpoint: "/patente", chiave: "patente" },
      {
        endpoint: "/turniaccessi",
        chiave: "turni_accessi",
      },
      {
        endpoint: "/offertaassistenza",
        chiave: "offerta_assistenza",
      },
      {
        endpoint: "/tipocollaborazione",
        chiave: "tipo_collaborazione",
      },
    ];
    // function to load all options
    const fetchOpzioni = async () => {
      setLoading(true);

      for (const config of configurazioni) {
        try {
          const response = await APICall.get(config.endpoint);
          const data = response.data;

          const nuoveOpzioni = data.map((item) => ({
            key: item[config.chiave], // item è il singolo elemento dell'array di oggetti data[{codice:FSK}, {codice: BAD}, ecc ecc], quindi diventa key:FSK alla prima iterazione su codice
            value: item[config.chiave],
            text: item[config.chiave],
          }));

          // Ordina le opzioni in ordine alfabetico in base al testo visualizzato
          const opzioniOrdinate = [...nuoveOpzioni].sort((a, b) => {
            // Gestione dei valori null o undefined
            if (!a.text && !b.text) return 0;
            if (!a.text) return 1;
            if (!b.text) return -1;

            // Ordinamento alfabetico per valori non null
            return a.text.localeCompare(b.text, "it", { sensitivity: "base" });
          });

          /**
           * prev rappresenta lo stato precedente dell'oggetto opzioni.
           * In React, quando si aggiorna uno stato utilizzando una funzione
           * di callback nel setter (in questo caso setOpzioni),
           * il primo parametro della callback è sempre il valore precedente dello stato.
           * Quindi stiamo inserendo, in questo ordine: il vecchio stato, il valore "Tutti" del dropdown, il nuovo stato aggiornato del singolo dropdown senza sovrascrivere quelli precedenti.
           */
          setOpzioni((prev) => ({
            ...prev,
            [config.chiave]: [
              { key: "", value: "", text: "Tutti" },
              ...opzioniOrdinate,
            ],
          }));
        } catch (error) {
          console.error(`Errore nel caricamento di ${config.endpoint}`, error);
        }
      }
    };
    setLoading(false);
    fetchOpzioni();
  }, []);

  // aggiorna lo stato parametri con il valore inserito nei campi di input. We need to pass (e) to handleChange because semantic UI passes (e) from the dropdown component onChange method.
  const handleChange = (e, { name, value }) => {
    setParametri((prevState) => ({ ...prevState, [name]: value }));
  };

  // trasforma l'oggetto parametri in un array dove ogni elemento è un altro array chiave=valore, costruisce la query string e la passa alla funzione onSearch
  const handleSubmit = () => {
    const queryString = Object.entries(parametri)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");
    onSearch(`?${queryString}`);
    console.log(queryString);
  };

  const handleReset = () => {
    setResetKey((prevKey) => prevKey + 1); // incrementa la chiave per forzare il reset dei campi
    setParametri({
      codice: "",
      nazionalita: "",
      zona: "",
      sesso: "",
      citta: "",
      asl: "",
      provincia: "",
      municipi: "",
      cap: "",
      coordinate: "",
      patente: "",
      data_consegna_inizio: "",
      data_consegna_fine: "",
      data_colloquio_contatto_inizio: "",
      data_colloquio_contatto_fine: "",
      nome_query: "",
      cognome_query: "",
      telefono_query: "",
    });
  };

  return (
    <div className="filter-form-container">
      <h2 className="subtitle">Filtri di ricerca</h2>
      <Form className="filters-form" key={resetKey} onSubmit={handleSubmit}>
        <div className="name-search-filters">
          <Form.Input
            type="text"
            label="Cerca per Nome"
            name="nome_query"
            onChange={(e) =>
              handleChange(e, { name: e.target.name, value: e.target.value })
            }
            value={parametri.nome_query}
          />
          <Form.Input
            type="text"
            label="Cerca per Cognome"
            name="cognome_query"
            onChange={(e) =>
              handleChange(e, { name: e.target.name, value: e.target.value })
            }
            value={parametri.cognome_query}
          />
        </div>
        <Form.Input
          type="text"
          label="Cerca per Telefono (ultime 4 cifre)"
          name="telefono_query"
          placeholder="Es: 7892"
          maxLength="4"
          pattern="[0-9]*"
          onChange={(e) =>
            handleChange(e, { name: e.target.name, value: e.target.value })
          }
          value={parametri.telefono_query}
        />
        <div className="date-filters-row">
          <div className="data-consegna-filters">
            <Form.Input
              type="date"
              label="Data Consegna da"
              name="data_consegna_inizio"
              onChange={(e) =>
                handleChange(e, { name: e.target.name, value: e.target.value })
              }
              value={parametri.data_consegna_inizio}
            />
            <Form.Input
              type="date"
              label="Data Consegna a"
              name="data_consegna_fine"
              onChange={(e) =>
                handleChange(e, { name: e.target.name, value: e.target.value })
              }
              value={parametri.data_consegna_fine}
            />
          </div>
          <div className="data-colloquio-contatto-filters">
            <Form.Input
              type="date"
              label="Data Colloquio da"
              name="data_colloquio_contatto_inizio"
              onChange={(e) =>
                handleChange(e, { name: e.target.name, value: e.target.value })
              }
              value={parametri.data_colloquio_contatto_inizio}
            />
            <Form.Input
              type="date"
              label="Data Colloquio a"
              name="data_colloquio_contatto_fine"
              onChange={(e) =>
                handleChange(e, { name: e.target.name, value: e.target.value })
              }
              value={parametri.data_colloquio_contatto_fine}
            />
          </div>
        </div>
        <Dropdown
          key="dropdown-codice"
          placeholder="Codice"
          fluid
          selection
          multiple
          search
          clearable
          closeOnEscape
          selectOnNavigation
          options={opzioni.codice}
          name="codice"
          onChange={handleChange}
        />
        <Dropdown
          key="dropdown-nazionalita"
          placeholder="Nazionalità"
          fluid
          selection
          multiple
          search
          clearable
          closeOnEscape
          selectOnNavigation
          options={opzioni.nazionalita}
          name="nazionalita"
          onChange={handleChange}
        />
        <Dropdown
          key="dropdown-cap"
          placeholder="Cap"
          fluid
          selection
          multiple
          search
          clearable
          closeOnEscape
          selectOnNavigation
          options={opzioni.cap}
          name="cap"
          onChange={handleChange}
        />
        <Dropdown
          key="dropdown-provincia"
          placeholder="Provincia"
          fluid
          selection
          multiple
          search
          clearable
          closeOnEscape
          selectOnNavigation
          options={opzioni.provincia}
          name="provincia"
          onChange={handleChange}
        />
        <Dropdown
          key="dropdown-citta"
          placeholder="Città"
          fluid
          selection
          multiple
          search
          clearable
          closeOnEscape
          selectOnNavigation
          options={opzioni.citta}
          name="citta"
          onChange={handleChange}
        />
        <Dropdown
          key="dropdown-zona"
          placeholder="Zona"
          fluid
          selection
          multiple
          search
          clearable
          closeOnEscape
          selectOnNavigation
          options={opzioni.zona}
          name="zona"
          onChange={handleChange}
        />
        <Dropdown
          key="dropdown-sesso"
          placeholder="Sesso"
          fluid
          selection
          options={opzioniSesso}
          name="sesso"
          onChange={handleChange}
        />
        <Dropdown
          key="dropdown-municipi"
          placeholder="Municipi / Distretti Roma"
          fluid
          selection
          multiple
          search
          clearable
          closeOnEscape
          selectOnNavigation
          options={opzioni.municipi_distretti_roma}
          name="municipi"
          onChange={handleChange}
        />
        <Dropdown
          key="dropdown-asl"
          placeholder="Asl"
          fluid
          selection
          multiple
          search
          clearable
          closeOnEscape
          selectOnNavigation
          options={opzioni.asl}
          name="asl"
          onChange={handleChange}
        />
        <Dropdown
          key="dropdown-coordinate"
          placeholder="Coordinate"
          fluid
          selection
          multiple
          search
          clearable
          closeOnEscape
          selectOnNavigation
          options={opzioni.coordinate}
          name="coordinate"
          onChange={handleChange}
        />
        <Dropdown
          key="dropdown-patente"
          placeholder="Patente"
          fluid
          selection
          multiple
          options={opzioni.patente}
          name="patente"
          onChange={handleChange}
        />
        <Dropdown
          search
          key="dropdown-turni-accessi"
          placeholder="Disponibilità"
          fluid
          selection
          multiple
          options={opzioni.turni_accessi}
          name="turni_accessi"
          onChange={handleChange}
        />
        <Dropdown
          key="dropdown-offerta-assistenza"
          placeholder="Offerta Assistenza"
          fluid
          selection
          multiple
          search
          clearable
          closeOnEscape
          selectOnNavigation
          options={opzioni.offerta_assistenza}
          name="offerta_assistenza"
          onChange={handleChange}
        />
        <Dropdown
          key="dropdown-tipo-collaborazione"
          placeholder="Tipo Collaborazione"
          fluid
          search
          selection
          multiple
          options={opzioni.tipo_collaborazione}
          name="tipo_collaborazione"
          onChange={handleChange}
        />
        <div className="filters-buttons-div">
          <Button type="submit" className="search-button">
            Cerca
          </Button>
          <Button type="button" className="reset-button" onClick={handleReset}>
            Reset
          </Button>
        </div>
      </Form>
    </div>
  );
}
